/**
 * 跟路由相关的方法函数
 */
import { objEqual, doTimes } from './index.js';
/**
 * 获取下一个路由
 * @param { array } routes 标签列表
 * @param { object } route 当前关闭的标签的route
 */
export const getNextRoute = (routes, route) => {
	let res = {};

	const index = routes.findIndex(item => {
		return routeEqual(item, route);
	});

	if (index === routes.length - 1) {
		res = routes[routes.length - 2];
	} else {
		res = routes[index + 1];
	}
	return res;
};

/**
 * 判断路由是否相等
 * @param { object } 路由1
 * @param { object } 路由2
 * @returns { boolean }
 */
export const routeEqual = (route1, route2) => {
	const params1 = route1.params || {};
	const params2 = route2.params || {};
	const query1 = route1.query || {};
	const query2 = route2.query || {};

	return (
		route1.name === route2.name &&
		objEqual(params1, params2) &&
		objEqual(query1, query2)
	);
};

/**
 * 判断路由是否已经存在
 * @param { array } 路由列表
 * @param { object } 路由
 * @returns { boolean }
 */
export const routeHasExist = (routes, route) => {
	let res = false;
	let len = routes.length;
	doTimes(len, index => {
		if (routeEqual(routes[index], route)) {
			res = true;
		}
	});
	return res;
};
